/* global IntersectionObserver, HTMLElement, customElements */

import wasmUrl from '@lottiefiles/dotlottie-web/dist/dotlottie-player.wasm?url'

const intersectionObserver = new IntersectionObserver((entries) => {
  for (const entry of entries) {
    if (entry.isIntersecting) {
      entry.target.loadAnimation()
    }
  }
})

class DotLottiePlayer extends HTMLElement {
  constructor () {
    super()

    this.dotLottie = null
    this._canInit = false
    this._played = false

    this.attachShadow({ mode: 'open' })
    this.canvas = document.createElement('canvas')
    this.canvas.style.width = '100%'
    this.canvas.style.height = '100%'
    this.shadowRoot.appendChild(this.canvas)
  }

  static get observedAttributes () {
    return ['src', 'loop', 'autoplay', 'mode', 'behavior']
  }

  attributeChangedCallback (name, oldValue, newValue) {
    if (oldValue !== newValue) {
      this.reset()
      this.loadAnimation()
    }
  }

  get behavior () {
    return this.getAttribute('behavior') || 'autoplay'
  }

  connectedCallback () {
    this._canInit = true

    if (this.behavior === 'when-visible') {
      intersectionObserver.observe(this)
    } else {
      this.loadAnimation()
    }
  }

  reset () {
    if (this.dotLottie) {
      this.dotLottie.destroy()
    }
  }

  loadAnimation () {
    if (!this._canInit) {
      return
    }

    if (this.dotLottie) {
      return Promise.resolve()
    }

    import('@lottiefiles/dotlottie-web').then(({ DotLottieWorker }) => {
    // Set the WASM URL
      DotLottieWorker.setWasmUrl(import.meta.env.DEV
        ? wasmUrl
        : window.location.origin + '/' + wasmUrl
      )

      this.dotLottie = new DotLottieWorker({
        canvas: this.canvas,
        src: this.getAttribute('src'),
        loop: this.hasAttribute('loop'),
        autoplay: true,
        mode: this.getAttribute('mode') || 'forward'
      })

      // this.dotLottie.addEventListener('load', (e) => { console.log('loaded') })
      // this.dotLottie.addEventListener('loadError', (e) => reject(e))
    })
  }
}

customElements.define('dotlottie-player', DotLottiePlayer)
